import { render, staticRenderFns } from "./SectionBusiness.vue?vue&type=template&id=0886914a&scoped=true"
import script from "./SectionBusiness.vue?vue&type=script&lang=ts"
export * from "./SectionBusiness.vue?vue&type=script&lang=ts"
import style0 from "./SectionBusiness.vue?vue&type=style&index=0&id=0886914a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0886914a",
  null
  
)

export default component.exports